module.exports = __webpack_public_path__ + "img/dp-sy-lm25.7fbdcb83.png";